import {
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
  Box,
  Button,
} from '@mui/material';
import { useTicketsSelector } from 'pages/ticketV2/store/ticketsStore';
import React, { useEffect, useState } from 'react';
import { DateButton } from '../style';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import translations from 'utils/translations';
import { useIntl } from 'react-intl';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { formatUTCDate } from '../utils';

const ModalContent = ({ onAccept, locale }) => {
  const { ticketToEditDates } = useTicketsSelector();
  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down('md'));
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const intl = useIntl();
  const isOperator = ticketToEditDates.role === 'operator';
  const i18nAssign = translations.TicketsV2(intl).Assign;
  const i18nCommon = translations.TicketsV2(intl).Common;
  const i18nErrors = i18nAssign.errors;
  const [selectedDates, setSelectedDates] = useState([]);
  const [error, setError] = useState({ title: '', message: '' });

  useEffect(() => {
    if (ticketToEditDates?.unparsedTicket?.slots?.length) {
      const _selectedDates = ticketToEditDates?.unparsedTicket?.slots.map(
        (s) => ({
          ...s,
          selected: !!ticketToEditDates.dates.find((d) =>
            d.reservation_start_date_time.includes(s.date)
          ),
        })
      );
      setSelectedDates(_selectedDates);
    }
  }, [ticketToEditDates]);

  const emptyError = () => setError({ title: '', message: '' });

  const onToggleDate = (date) => {
    emptyError();
    const currentTicket = ticketToEditDates?.unparsedTicket.product;
    const prevReservations = selectedDates.map((res) => ({
      ...res,
      ...(date === res.date &&
        res.selected && {
          selected: !res.selected,
        }),
    }));
    const selectedCount = prevReservations.filter((res) => res.selected).length;
    /**
     * Selected Too Much Dates
     */
    if (selectedCount === currentTicket.capacity && !isOperator) {
      const isSingleDay = currentTicket.capacity === 1;
      // const title = `${i18nErrors.tooMuchDates.warning} ${
      //   currentTicket.capacity
      // } ${i18nErrors.tooMuchDates[isSingleDay ? 'date' : 'dates']}`;
      const title = '';
      const message = `${i18nErrors.tooMuchDates.forThis} ${
        i18nErrors.tooMuchDates.onlySelect
      } ${currentTicket.capacity} ${
        i18nErrors.tooMuchDates[isSingleDay ? 'date' : 'dates']
      }`;
      const _error = {
        title,
        message,
      };
      return setError(_error);
    }
    const nextReservations = selectedDates.map((res) => ({
      ...res,
      ...(date === res.date &&
        (res.selected ||
          selectedCount !== ticketToEditDates?.unparsedTicket.capacity) && {
          selected: !res.selected,
        }),
    }));

    setSelectedDates(nextReservations);
  };

  const handleSubmit = () => {
    emptyError();
    const currentTicket = ticketToEditDates?.unparsedTicket.product;
    const selectedReservations = selectedDates.filter((s) => s.selected);
    const hasSelectedDates = selectedReservations.length;
    const enoughDate = selectedDates.length >= currentTicket.capacity;
    const datesToSelectCount = enoughDate
      ? currentTicket.capacity
      : selectedDates.length;
    /**
     * Not Enough Date
     */
    if (
      !isOperator &&
      ((enoughDate && selectedReservations.length < currentTicket.capacity) ||
        (!enoughDate && selectedReservations.length < selectedDates.length))
    ) {
      const title = `${i18nErrors.missingDates.warning} ${
        hasSelectedDates ? '' : `${i18nErrors.missingDates.all}`
      } ${i18nErrors.missingDates.the} ${datesToSelectCount} ${
        i18nErrors.missingDates.dates
      }`;
      const message = `${i18nErrors.missingDates.before} ${i18nErrors.missingDates.selectDates}`;
      const _error = {
        title,
        message,
      };
      return setError(_error);
    }
    /**
     * Operator need One Day
     */
    if (isOperator && selectedReservations.length < 1) {
      const title = '';
      const message = `${i18nErrors.operatorOneDate.title}`;
      const _error = {
        title,
        message,
      };
      return setError(_error);
    }
    onAccept(selectedDates);
  };

  return (
    <>
      <Stack
        direction={'row'}
        gap={isSmDown ? '15px' : '25px'}
        alignItems={'center'}
        justifyContent={isMdDown && isOperator ? 'center' : 'flex-start'}
        flexWrap={'wrap'}
      >
        {selectedDates?.map((res) => (
          <DateButton
            key={res.date}
            variant="contained"
            onClick={() => onToggleDate(res.date)}
            selected={res.selected}
            sx={{ width: 120, p: '10px' }}
          >
            <span>{formatUTCDate({ date: res.date, locale })}</span>
            {res.selected && <CheckOutlinedIcon fontSize="small" />}
          </DateButton>
        ))}
        {error.message ? (
          <Typography
            variant="body1-bold"
            textAlign={'center'}
            width={'100%'}
            color={theme.palette.primary.main}
          >
            {error.message}
          </Typography>
        ) : null}
      </Stack>
      {isOperator ? (
        <Box
          bgcolor={'#EEEEEE'}
          border={'1px solid #A3A3A3'}
          padding={'30px 15px'}
        >
          <Stack flexDirection={'row'} gap={'15px'} alignItems={'flex-start'}>
            <InfoOutlinedIcon sx={{ color: '#333333' }} />
            <Stack>
              <Typography variant="body1-bold" sx={{ mb: '15px' }}>
                {i18nAssign.operatorBoxTitle}
              </Typography>
              <Typography variant="body1">
                {i18nAssign.operatorBoxSubTitleOne}
              </Typography>{' '}
            </Stack>
          </Stack>
        </Box>
      ) : null}
      <Stack
        flexDirection={'row'}
        alignItems={'center'}
        justifyContent={'center'}
        marginTop={'25px'}
      >
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          {i18nCommon.save}
        </Button>
      </Stack>
    </>
  );
};
export default ModalContent;
